import isEmpty from 'lodash/isEmpty';
const initialState = {

  }
  const dashboard = (state = initialState , action) =>{
    switch (action.type) {

      case 'SET_DASHBOARD':
          return {
          ...state,
            dashboardData: action.data,
            success: action.data.success,
          }

      case 'FAIL_DASHBOARD':
        return {
        ...state,
        dashboardFailMsg: action.message,
        success: action.success,
        }

          default:
          return state;
        }
  };
export default dashboard;



// WEBPACK FOOTER //
// ./src/reducers/dashboard.js